module.exports = __webpack_public_path__ + "img/my-coin-gold.24c67ab4.png";